<template>
  <foldable-card
    non-foldable
    title="Review Error Rows"
    description='We are showing you the employees that cannot be imported on this page.
        You can save the remaining employees by clicking "Save Employees not Shown" at the bottom of the page.'
  >
    <v-data-table
      class="main-table preview-table"
      :headers="headers"
      :items="employees"
      hide-default-footer
      disable-sort
      :options="tableOptions"
    >
      <template v-slot:item="{ item, headers }">
        <tr>
          <td
            v-for="(header, colId) in headers"
            :key="`cell-${item.rowIndx}-${colId}`"
            :class="getError(item.rowIndx, colId) && 'has-error'"
          >
            <v-tooltip
              bottom
              nudge-top="10"
              v-if="getError(item.rowIndx, colId)"
            >
              <template v-slot:activator="{ on, attrs }">
                <div class="error-highlight" v-bind="attrs" v-on="on">
                  {{ item[header.value] }}
                </div>
              </template>
              <div class="pa-1">
                <span class="error-header pa-1 mr-1">{{ header.text }}</span>
                <span class="error-content">{{
                  getError(item.rowIndx, colId)
                }}</span>
              </div>
            </v-tooltip>

            <span v-else>
              {{ item[header.value] }}
            </span>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="d-flex justify-space-between mt-9">
      <v-btn @click="$emit('reset')" color="colorUiGrey30" depressed
        >Back</v-btn
      >
      <v-btn
        @click="confirmSave"
        color="primary"
        depressed
        :disabled="!enableSave"
        :loading="loading"
        >Save Employees not Shown</v-btn
      >
    </div>
  </foldable-card>
</template>

<script>
import FoldableCard from "@/components/FoldableCard";
import hasNotifications from "@/mixins/has-notifications";

const tableOptions = {
  itemsPerPage: -1
};

export default {
  name: "EmployeesPreview",
  components: {
    FoldableCard
  },
  mixins: [hasNotifications],
  props: {
    validationErrors: Array,
    employees: Array,
    enableSave: Boolean
  },
  data: () => ({
    headers: [
      { text: " ", value: "rowIndx", width: 32, align: "center" },
      { text: "SSN", value: "ssn" },
      { text: "First Name", value: "firstName" },
      { text: "Last Name", value: "lastName" },
      { text: "DOB", value: "dob" },
      { text: "Street 1", value: "street1" },
      { text: "Street 2", value: "street2" },
      { text: "City", value: "city" },
      { text: "State", value: "state" },
      { text: "Zip", value: "postalCode" }
    ],
    loading: false,
    tableOptions
  }),
  methods: {
    getError(rowIndx, colIndx) {
      return this.indexedValidationErrors[`${rowIndx}-${colIndx}`];
    },
    confirmSave() {
      this.setAlert({
        title: "Proceed to save?",
        description:
          "We will save the employees that we were able to process. Any employees shown in the table on this page will not be saved. You will need to make corrections and upload them later.",
        cancelText: "Cancel",
        actionFn: () => {
          this.loading = true;
          this.$emit("save");
        }
      });
    }
  },
  computed: {
    indexedValidationErrors() {
      if (!this.validationErrors) return {};
      return this.validationErrors.reduce((acc, crt) => {
        acc[`${crt.rowIndx}-${crt.colIndx}`] = crt.errorMessage;
        return acc;
      }, {});
    }
  }
};
</script>

<style lang="sass" scoped>
.preview-table ::v-deep table
  border-collapse: collapse
  th
    height: 24px
    padding: 3px 12px
    &:first-child
      border-right: none
    &:nth-child(2)
      border-left: none
    color: $color-ui-grey-90 !important
  td
    height: 32px
    padding: 6px 12px
    color: $color-pt-black
    /* not contain colspan which means no data */
    &:first-child:not([colspan])
      background-color: $color-ui-grey-10
    &.has-error
      padding: 0
      .error-highlight
        width: 100%
        height: 100%
        border: 1px solid $color-alert-red
        background-color: $color-alert-red-lt
        color: $color-alert-red
        display: flex
        align-items: center
        padding-left: 12px
        padding-right: 12px
  th, td
    border: 1px solid $color-ui-grey-30
    white-space: nowrap
.error-header
  background-color: $color-alert-red-lt
  border-radius: 4px
  color: $color-alert-red
  font-weight: 700
.error-content
  /* the following styling doesn't work well with v-tooltip, although it is in the mockup */
  //color: $color-pt-black
  font-weight: 600
</style>
